import bowser from 'yola-bowser';

const isOldIOSBrowser = () => bowser.ios && parseInt(bowser.version, 10) < 13;

export default isOldIOSBrowser;
